// extracted by mini-css-extract-plugin
export var cardTitle = "_jz-1";
export var commentBubble = "_jz-e";
export var commentForm = "_jz-a";
export var commentInput = "_jz-b";
export var commentLabel = "_jz-d";
export var commentPrompt = "_jz-9";
export var csatCard = "_jz-0";
export var feedbackSection = "_jz-7";
export var starDisabled = "_jz-6";
export var starEmpty = "_jz-5";
export var starFilled = "_jz-4";
export var starWrapper = "_jz-3";
export var starsContainer = "_jz-2";
export var submittedComment = "_jz-c";
export var thankYouText = "_jz-8";